/* global module, require */
const entries = require('./objectEntries');

module.exports = function firstOption(options) {
	return entries(options)[0][1];
};
